import * as Tooltip from '@radix-ui/react-tooltip'
import { useState } from 'react'
import { BiInfoCircle } from 'react-icons/bi'

import { PriceBy, PriceByProps } from '../PriceBy'

import './styles.scss'

type InteractiveLabelProps = {
  children: React.ReactNode
  required?: boolean
  info?: string
  priceBy?: PriceByProps
} & React.LabelHTMLAttributes<HTMLLabelElement>

export function InteractiveLabel({
  children,
  required = false,
  info,
  priceBy,
  ...props
}: InteractiveLabelProps) {
  const [open, setOpen] = useState(false)

  return (
    <div className="interactive-label-wrapper">
      <label className="interactive-label" {...props}>
        {children}
        {required && (
          <>
            <span className="interactive-label__required" aria-hidden>
              *
            </span>
            <span className="sr-only">obrigatório</span>
          </>
        )}

        {info && (
          <Tooltip.Provider delayDuration={0}>
            <Tooltip.Root onOpenChange={setOpen} open={open}>
              <Tooltip.Trigger asChild>
                <div className="interactive-label__info-icon">
                  <button
                    type="button"
                    onClick={() => setOpen(!open)}
                    aria-label="Mais informações"
                  >
                    <BiInfoCircle aria-hidden />
                  </button>
                </div>
              </Tooltip.Trigger>

              <Tooltip.Portal>
                <Tooltip.Content className="tooltip" sideOffset={8}>
                  {info}
                  <Tooltip.Arrow />
                </Tooltip.Content>
              </Tooltip.Portal>
            </Tooltip.Root>
          </Tooltip.Provider>
        )}
      </label>

      {priceBy && <PriceBy {...priceBy} />}
    </div>
  )
}
